import $ from 'jquery';

$(document).on('fields_added.nested_form_fields', () => {
  $('.nested_fields').scTooltips();
});
